const PROD = {
  AORTA_HOST: "https://auth.eka.care",
  AORTA_GO_HOST: "https://aortago.eka.care",
  TRYST_HOST: "https://tryst.eka.care",
  AXON_HOST: "https://axon.eka.care",
  PARCHI_HOST: "https://parchi.eka.care",
  CURIO_HOST: "https://eka.care",
  AVATAR_HOST: "https://a.eka.care",
  PTDIR_HOST: "https://ptdir.eka.care",
  TELE_HOST: "https://mweb.eka.care",
  METROLPOLIS_HOST: "https://consultation.metropolisindia.com",
  LUCID_WS_HOST: "https://lucid-ws.eka.care",
  LUCID_HOST: "https://lucid.eka.care",
  DEEPTHOUGHT_HOST: "https://deepthought.eka.care",
  NDHM_HOST: "https://api.eka.care",
  LOGIN_HOST: "https://login.eka.care",
  HUB: "https://hub.eka.care",
  RECEIPT_DOMAIN: "https://doc-receipts.eka.care",
};

const DEV = {
  AORTA_HOST: "https://aorta.dev.eka.care",
  AORTA_GO_HOST: "https://aortago.dev.eka.care",
  // AORTA_GO_HOST: "https://aortago.eka.care",
  // AORTA_GO_HOST: "https://aortago-pp.eka.care",
  TRYST_HOST: "https://tryst.dev.eka.care",
  AXON_HOST: "https://axon.dev.eka.care",
  PARCHI_HOST: "https://parchi.dev.eka.care",
  CURIO_HOST: "https://curio.dev.eka.care",
  AVATAR_HOST: "https://eka-avatar.dev.eka.care",
  PTDIR_HOST: "https://ptdir.dev.eka.care",
  TELE_HOST: "https://mweb.dev.eka.care",
  METROLPOLIS_HOST: "https://consultation.metropolisindia.com",
  LUCID_WS_HOST: "https://lucid-ws.dev.eka.care",
  LUCID_HOST: "https://lucid.dev.eka.care",
  DEEPTHOUGHT_HOST: "https://deepthought.dev.eka.care",
  NDHM_HOST: "https://api.dev.eka.care",
  LOGIN_HOST: "https://login.dev.eka.care",
  HUB: "https://hub.dev.eka.care",
  RECEIPT_DOMAIN: "https://doc-receipt.s3.ap-south-1.amazonaws.com",
};

let envVar = DEV;
let client_id = "";
let refresh_token = "";
let journey_id = "";
let hipId = "";
let counter_id = "";
let extraHeaders: Record<string, string> | null = null;

type TSetEnvParams = {
  env: "PROD" | "DEV";
  clientId: string;
  extraHeaders?: Record<string, string>;
};

const setEnv = ({
  env,
  clientId,
  extraHeaders: newExtraHeaders,
}: TSetEnvParams) => {
  envVar = env === "PROD" ? PROD : DEV;
  client_id = clientId;
  if (newExtraHeaders) {
    extraHeaders = newExtraHeaders;
  }
};

export const setIndividualEnv = ({
  clientId: newClientId,
  env: newEnv,
  extraHeaders: newExtraHeaders,
}: Partial<TSetEnvParams>) => {
  if (newClientId) {
    client_id = newClientId;
  }
  if (newEnv) {
    envVar = newEnv === "PROD" ? PROD : DEV;
  }
  if (newExtraHeaders) {
    extraHeaders = { ...extraHeaders, ...newExtraHeaders };
  }
};

export const setRefreshToken = (token: string) => { 
  refresh_token = token;
};

export const GET_REFRESH_TOKEN = () => {
  return refresh_token;
};

export const setRegJourneyId = (regJourneyId: string) => { 
  journey_id = regJourneyId;
};

export const GET_REG_JOURNEY_ID = () => {
  return journey_id;
};

export const setHipId = (hipid: string) => { 
  hipId = hipid;
};

export const GET_HIP_ID = () => {
  return hipId;
};

export const setCounterId = (cid: string) => { 
  counter_id = cid;
};

export const GET_COUNTER_ID = () => {
  return counter_id;
};

export const GET_AORTA_HOST = () => envVar.AORTA_HOST;
export const GET_AORTA_GO_HOST = () => envVar.AORTA_GO_HOST;
export const GET_TRYST_HOST = () => envVar.TRYST_HOST;
export const GET_AXON_HOST = () => envVar.AXON_HOST;
export const GET_PARCHI_HOST = () => envVar.PARCHI_HOST;
export const GET_CURIO_HOST = () => envVar.CURIO_HOST;
export const GET_AVATAR_HOST = () => envVar.AVATAR_HOST;
export const GET_PTDIR_HOST = () => envVar.PTDIR_HOST;
export const GET_TELE_HOST = () => envVar.TELE_HOST;
export const GET_METROPOLIS_HOST = () => envVar.METROLPOLIS_HOST;
export const GET_LUCID_WS_HOST = () => envVar.LUCID_WS_HOST;
export const GET_LUCID_HOST = () => envVar.LUCID_HOST;
export const GET_DEEPTHOUGHT_HOST = () => envVar.DEEPTHOUGHT_HOST;
export const GET_NDHM_HOST = () => envVar.NDHM_HOST;
export const GET_LOGIN_HOST = () => envVar.LOGIN_HOST;
export const GET_HUB_HOST = () => envVar.HUB;
export const GET_CLIENT_ID = () => client_id;
export const RECEIPT_DOMAIN = () => envVar.RECEIPT_DOMAIN;
export const GET_EXTRA_HEADERS = () => extraHeaders;
export const GET_ABHA_SDK_VERSION = () => "1.0.0";
export default setEnv;